import { render, staticRenderFns } from "./HallOfFamePage.vue?vue&type=template&id=54a5cbc6&scoped=true&"
import script from "./HallOfFamePage.vue?vue&type=script&lang=js&"
export * from "./HallOfFamePage.vue?vue&type=script&lang=js&"
import style0 from "./HallOfFamePage.vue?vue&type=style&index=0&id=54a5cbc6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5cbc6",
  null
  
)

export default component.exports